import type { MouseEvent } from "react";

/** Modifier-clicks fall through to the browser so the link still opens in a new tab or window. */
export const navigateOnPlainClick = (event: MouseEvent<HTMLElement>, navigate: () => void): void => {
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) {
        return;
    }
    event.preventDefault();
    navigate();
};
